import * as React from 'react';

interface SegmentContainerProps {
  variant?: string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
}
interface VariantProps {
  [key: string]: string;
}

const variantStyles: VariantProps = {
  chosen: 'border-navy bg-white cursor-auto py-2.5 px-3',
  chosenWithoutMarginBottom: 'border-navy bg-white cursor-auto mb-0 rounded-t py-2.5 px-3',
  chosenWithoutSpacing: 'border-navy bg-white cursor-auto p-0 m-0',
  default:
    'w-full cursor-pointer bg-[rgba(255,255,255,0.5)] border-t-4 border-transparent rounded box-border py-2.5 px-3 inline-block'
};

const SegmentContainer: React.FC<SegmentContainerProps> = ({ variant, className, children, onClick }) => {
  return (
    <div
      className={`w-full border-t-4 inline-block rounded-sm ${
        (variant && variantStyles[variant]) || variantStyles.default
      } !${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default SegmentContainer;
